import {
	IonButton,
	IonButtons,
	IonFooter,
	IonHeader,
	IonIcon,
	IonPage,
	IonText,
	useIonRouter,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import background from "@/assets/nl/explain-reflection-background.png";
import main_content from "@/assets/nl/explain-reflection-bubble.png";
import { Button } from "@/components/Global/Button";
import { Content } from "@/components/Global/Content";
import { Toolbar } from "@/components/Global/Toolbar";
import { Loading } from "@/components/Loading";
import { useReflection } from "@/lib/hooks/useReflection";
import { arrowLeftIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { Routes } from "@/lib/router";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ReflectionExplainer() {
	const presentModal = useSelectorModalStore.use.present();
	const { t, i18n } = useTranslation();
	const router = useIonRouter();
	const { service: reflectionService, isLoading: isReflectionLoading } = useReflection();

	if (isReflectionLoading) {
		return <Loading />;
	}

	return (
		<IonPage>
			<IonHeader className="ion-no-border">
				<Toolbar className="ion-p-2 plt-desktop:sm:ion-px-[max(calc(calc(100vw-640px)/2),--spacing(4))]">
					<IonButtons slot="secondary" className="flex w-full justify-between">
						<IonButton
							data-attr="page.reflection.explainer.back"
							data-touch-target
							routerLink={Routes.Dashboard()}
							routerDirection="back"
							color="light"
							className="part-icon:m-0 part-icon:size-5 part-native:size-10 part-native:min-h-0 part-native:rounded-full part-native:bg-brown-300 part-native:p-1 part-native:text-xs part-native:text-brown-600 min-h-0"
						>
							<IonIcon icon={arrowLeftIcon} />
						</IonButton>
					</IonButtons>
				</Toolbar>
			</IonHeader>
			<Content scrollY={false}>
				<div className="flex h-full flex-col">
					<div className="flex-1">
						<div className="relative mx-auto h-full w-full max-w-[800px]">
							<img
								alt=""
								src={{ nl: background }[i18n.language]}
								className="absolute inset-0 h-full w-full object-cover select-none md:object-contain"
								aria-hidden="true"
							/>

							<img
								src={{ nl: main_content }[i18n.language]}
								className="absolute top-[15%] left-1/2 h-full max-w-[620px] -translate-x-1/2 -translate-y-1/2 object-contain md:top-1/2 md:w-[65%]"
								alt={t("reflection.empty-page.image-alt")}
							/>
						</div>
					</div>

					<div className="mx-auto flex w-full max-w-[800px] flex-col gap-1">
						<IonText className="text-brown-700 text-3xl font-bold">
							{t("reflection.empty-page.title")}
						</IonText>
						<IonText className="text-brown-600 text-md text-pretty">
							{t("reflection.empty-page.message")}
						</IonText>
					</div>
				</div>
			</Content>

			<IonFooter>
				<div className="plt-desktop:sm:px-[max(calc(calc(100vw-640px)/2),--spacing(4))] p-4">
					<Button
						data-attr="page.app.friend-check.empty.action"
						className="w-full"
						onClick={() => {
							presentModal("reflectionExplainerGeneral", {
								onCompleted: () => {
									router.push(reflectionService.router.question(), "none", "push");
								},
							});
						}}
					>
						{t("reflection.empty-page.action")}
					</Button>
				</div>
			</IonFooter>
		</IonPage>
	);
}
